import React, { useState } from 'react'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import { useModel } from 'umi'
import { Modal, Checkbox, Tooltip, Button } from 'antd'
import { Input } from '@/ui'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CustomIcon from '@/components/CustomIcon'
import styles from './index.less'

const TIME_OUT = 64

const DragHandle = SortableHandle(() => {
    return (
        <div className={styles.drag}>
            <Tooltip overlay={null} title="拖拽排序">
                <CustomIcon className={styles.dragIcon} type="icon-a-Group1000008508" />
            </Tooltip>
        </div>
    )
})

const SortableItem = SortableElement(({ label, checkable, deletable, checked, onCheckChange, onDelete }) => {
    const handleCheckChange = () => {
        onCheckChange(!checked)
    }

    return (
        <div className={styles.item}>
            {checkable ? (
                <div onClick={handleCheckChange} className={styles.checkedLabel}>
                    <Tooltip overlay={null} title="系统默认的处理结果可以设置显示/隐藏">
                        <Checkbox style={{ marginRight: 6 }} checked={checked} />
                    </Tooltip>
                    <Tooltip overlay={null} title={label} placement="topLeft">
                        <div className={styles.label}>{label}</div>
                    </Tooltip>
                </div>
            ) : (
                <div className={styles.uncheckedLabel}>
                    <Tooltip overlay={null} title={label} placement="topLeft">
                        <div className={styles.label}>{label}</div>
                    </Tooltip>
                </div>
            )}
            {deletable && (
                <Tooltip overlay={null} title="若不需要该自定义处理结果，可以删除">
                    <div className={styles.delete} onClick={onDelete}>
                        <CustomIcon className={styles.deleteIcon} type="icon-shanchu1" />
                    </div>
                </Tooltip>
            )}
            <DragHandle />
        </div>
    )
})

const SortableList = SortableContainer(() => {
    const {
        tempList: list,
        tempCheckedValue: checkedValue,
        checkProcessingResult,
        deleteProcessingResult
    } = useModel('useAfterSalesProcessingResults', model => ({
        tempList: model.tempList,
        tempCheckedValue: model.tempCheckedValue,
        checkProcessingResult: model.checkProcessingResult,
        deleteProcessingResult: model.deleteProcessingResult
    }))

    return (
        <div className={styles.list} id="processingResult">
            {list.map((item, index) => (
                <SortableItem
                    key={item.text}
                    index={index}
                    checkable={item.system}
                    deletable={!item.system}
                    checked={checkedValue[item.text]}
                    label={item.text}
                    onCheckChange={checked => checkProcessingResult(item.text, checked)}
                    onDelete={() => deleteProcessingResult(item.text)}
                />
            ))}
        </div>
    )
})

const Content = () => {
    const [input, setInput] = useState('')
    const { addProcessingResult, sortProcessingResult } = useModel('useAfterSalesProcessingResults', model => ({
        addProcessingResult: model.addProcessingResult,
        sortProcessingResult: model.sortProcessingResult
    }))

    const handleSortEnd = ({ oldIndex, newIndex }) => {
        sortProcessingResult(oldIndex, newIndex)
    }

    const haddleAdd = () => {
        if (addProcessingResult(input)) {
            setInput('')
            setTimeout(() => {
                document.getElementById('processingResult')?.scrollTo({
                    top: 99999,
                    behavior: 'auto'
                })
            }, TIME_OUT)
        }
    }

    return (
        <div>
            <div className={styles.row}>
                <div className={styles.rowLabel}>新增处理结果</div>
                <Input.Group compact>
                    <Input
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        style={{ width: 'calc(100% - 64px)' }}
                        placeholder="请输入"
                        maxLength={50}
                        allowClear
                        onPressEnter={haddleAdd}
                    />
                    <Button onClick={haddleAdd} className={styles.rowBtn} type="primary" icon={<CheckOutlined />} />
                </Input.Group>
            </div>
            <SortableList helperClass={styles.sortHelper} lockAxis="y" useDragHandle onSortEnd={handleSortEnd} />
        </div>
    )
}

const AddProcessingResultsModal = ({ visible, onCancel }) => {
    const { updateList, updateLoading } = useModel('useAfterSalesProcessingResults', model => ({
        updateList: model.updateList,
        updateLoading: model.updateLoading
    }))

    const handleOk = async () => {
        await updateList()
        onCancel()
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            confirmLoading={updateLoading}
            title="设置处理结果"
            onOk={handleOk}
        >
            <Content />
        </Modal>
    )
}

export default AddProcessingResultsModal
